var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchWhite = function SvgSearchWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "search-icon",
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m21.54 20.48-4.693-4.694a8.26 8.26 0 1 0-1.06 1.06l4.692 4.695a.75.75 0 1 0 1.062-1.062ZM3.76 10.51a6.75 6.75 0 1 1 6.75 6.75 6.757 6.757 0 0 1-6.75-6.75Z"
  })));
};
export default SvgSearchWhite;